import React, { useState } from 'react'
import styled, { keyframes } from 'styled-components'
import { RCWidth, base, deepClone } from '../utils'
import google from '../media/google.png'
import bing from '../media/bing2.png'
import Loading from './Loading'
import { useDispatch, useSelector } from 'react-redux'
import { doc, updateDoc } from 'firebase/firestore'
import { db } from '../firebase'
import { redNex } from '../Redux/nexSlice'

function IndexedPages({ nexListn, _nex }) {
    const [data, setData] = useState([{google: null, bing: null}])
    const [url, setUrl] = useState('')

    const [isLoading, setIsLoading] = useState(false)

    const [noInput1, setNoInput1] = useState(false)

    const user = useSelector(state=> state.user.user)
    const nx = useSelector(state=> state.nex.nex)

    const dispatch = useDispatch()

    const getData = async () => {
      setIsLoading(true)
        if(url !== '') {
          setNoInput1(false)

          const updateAnalytics = async () => {
            const tool = window.location.pathname.split('/').pop();
            let tools = deepClone(user.analytics.toolsUsage);
        
            if (isNaN(tools[tool]) || tools[tool] == 'NaN') {
                tools[tool] = 1;
            } else {
                tools[tool] = Number(tools[tool]) + 1;
            }
        
            await updateDoc(doc(db, 'users', user.id), { analytics: { toolsUsage: tools } });
        };

            fetch(`${base}/res`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                type: 'ip',
                url: url,
                userId: user.id
              })
            }).then(res=> res.json()).then(data=> {
              setData(data)
              setIsLoading(false)
              dispatch(redNex(nx))
              updateAnalytics()
            })
          } else {
            if(url.trim() === '') setNoInput1(true)
          }
    }




  return (
    <IndexedPagesContainer>
            <IndexedPagesInputContainer>
                <h2>Indexed Pages <span style={{fontSize: 'medium', marginLeft: '20px'}}></span></h2>
                <IndexedPagesInputInnerContainer>
                <div style={{position: 'relative', marginBottom: '20px'}}><label style={{position: 'absolute', transform: 'translateY(-70%)', left: '23px', top: '20%', fontSize: 'small'}}>Enter Website</label><input type='url' placeholder='example.com' style={{marginLeft: '20px', borderColor: noInput1? 'red': ''}} value={url} onChange={e=> setUrl(e.target.value)}/></div>
                {nx !== 0 && <button onClick={()=> !isLoading? getData() : ()=> {}} style={isLoading ? {backgroundColor: 'lightgray', color: 'gray', cursor: 'not-allowed'}: {}}>{!isLoading ?'Get Data': 'Getting Data ...'}</button>}
          {nx === 0 && <button style={{backgroundColor: 'lightgray', color: 'red', cursor: 'not-allowed'}}>Insufficient Nexilum units!</button>}
                </IndexedPagesInputInnerContainer>
            </IndexedPagesInputContainer>

            {data[0].google !== null && !isLoading && <IndexedPagesResContainer>
                <div>
                    <div><img src={google} alt='google' /></div>
                    <h3>{isNaN(Number(data[0].google.replaceAll(/,/g, '')))? "No data was found in Google's indexes": data[0]?.google}</h3>
                    {isNaN(Number(data[0].google.replaceAll(/,/g, '')))? '': <p>Pages indexed by Google</p>}
                </div>

                <div>
                <div><img src={bing} alt='google' /></div>
                <h3>{isNaN(Number(data[0].bing.replaceAll(/,/g, '')))? "No data was found in Bing's indexes": data[0]?.bing}</h3>
                {isNaN(Number(data[0].bing.replaceAll(/,/g, '')))? '': <p>Pages indexed by Bing</p>}
                </div>
            </IndexedPagesResContainer>}
            {isLoading && <Loading />}

            {(data[0].google == null && data[0].bing === null) && !isLoading && <Intro>

              <h3>Tool Overview</h3>
              <br />
              <p>
                The Indexed Pages Tool allows you to check how many pages from your site are indexed by Google and Bing. 
                By monitoring your indexed pages, you can ensure your content is being properly crawled and indexed, improving your site’s visibility in search results.
              </p>
              <br /><br />
              
              <h3>Instructions</h3>
              <br />
              <p>1. Enter your website URL in the search bar</p>
              <p>2. Click "Get Data" to view the number of pages indexed by Google and Bing</p>
              <br /><br />
              
              <h3>Tips</h3>
              <br />
              <p>Regularly monitor your indexed pages to identify any indexing issues and ensure all important pages are being indexed by search engines</p>

            </Intro>}
    </IndexedPagesContainer>
  )
}

export default IndexedPages


const IndexedPagesContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: ${RCWidth};
`

const fadeInAnimation = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`

const IndexedPagesInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 3px;
  box-shadow: 2px 2px 16px -8px rgb(239, 239, 239);
  background-color: white;
  margin-inline: 20px;
  padding: 20px;
  margin-top: 25px;
  z-index: 2;

  > h2 {
    font-weight: 100;
    margin-bottom: 20px;
  }

  > div > input {
    outline: none;
    border-radius: 2px;
    width: 200px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    color: var(--se-color);
  }

  > div > input::placeholder {
    color: rgba(180, 180, 180);
  }

  > div > .select-country {
    outline: none;
    border-radius: 2px;
    width: 200px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    margin-left: 20px;
    color: var(--se-color);
  }

  > div > button {
    border: none;
    border-radius: 2px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    padding: 5px;
    margin-left: 60px;
    cursor: pointer;
    background-color: var(--se-color);
    color: white;
  }

  > div > button:hover {
    color: var(--se-color);
    background-color: rgb(239, 239, 239);
  }
`

const IndexedPagesInputInnerContainer = styled.div`
  display: flex;
  margin-top: 20px;

  > div > input {
    outline: none;
    border-radius: 2px;
    width: 200px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    color: var(--se-color);
    padding-left: 100px;
    font-size: medium;
  }

  > div > input::placeholder {
    color: rgba(180, 180, 180);
  }
`


const IndexedPagesResContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding: 10px;
  margin: 20px;
  overflow-x: hidden;
  overflow-y: hidden;
  background-color: white;
  border-radius: 2px;
  z-index: 2;
  margin-bottom: 70px;
  padding-bottom: 10px;

  > div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 500px;
    height: 300px;
    border-radius: 5px;
    padding: 10px;
    margin: 20px;
  }

  > div > div {
    height: 150px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  > div > div > img {
    width: 260px;
    object-fit: contain;
    margin-bottom: 30px;
  }

  > div > h3 {
    font-weight: 200;
  }


  > div > p {
    margin-top: 10px;
  }
`


const Intro = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px 20px 20px 20px;

  opacity: 0;
  animation: ${fadeInAnimation} 0.3s ease-in-out forwards;

  > h3 {
    color: white;
    font-family: 'Quicksand';
    font-weight: 500;
  }

  > p {
    color: white;
    font-family: 'Quicksand';
    width: 60%;
  }
`